export interface Partner {
  imageUrl: string;
  website: string;
  alt: string;
}

const urlPrefix = '/partner';

const partners: Partner[] = [
  {
    imageUrl: `${urlPrefix}/deba-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.deba.at/de',
    alt: 'deba-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/teamneunzehn-makler-neubauprojekte-wien.svg`,
    website: 'https://www.teamneunzehn.at/',
    alt: 'teamneunzehn-makler-neubauprojekte-wien',
  },

  {
    imageUrl: `${urlPrefix}/aure-immobilien-maler-neubauprojekte-wien.svg`,
    website: 'https://www.austro-residenz.at/',
    alt: 'aure-immobilien-maler-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/sieben-dörfer-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.7doerfer.at/',
    alt: 'sieben-dörfer-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/3SI-Immobilien-makler-neubauprojekte-wien.svg`,
    website: 'https://www.3si.at/de/',
    alt: '3si-makler-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/decus-makler-neubauprojekte-wien.svg`,
    website: 'https://www.decus.at/de',
    alt: 'decus neubauprojekte',
  },
  {
    imageUrl: `${urlPrefix}/ms-bau-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://msbau.at/',
    alt: 'ms-bau-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/project-immobilien-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.project-immobilien.at/',
    alt: 'project-immobilien-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/liv-makler-neubauprojekte-wien.svg`,
    website: 'https://www.liv.at/',
    alt: 'liv-makler-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/3SI-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.3si.at/de/',
    alt: '3si-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/galerie-immobilien-makler-neubauprojekte-wien.svg`,
    website: 'https://www.galerie-immobilien.at/',
    alt: 'galerie-immobilien-makler-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/aira-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.aira.at/',
    alt: 'aira-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/sangreal-properties-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.sangreal-properties.at/',
    alt: 'sangreal-properties',
  },
  {
    imageUrl: `${urlPrefix}/valetono-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.valetono.at/',
    alt: 'valetono-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/hart-hart-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.hart-hart.at/',
    alt: 'hart-hart-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/emp-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.emp-immo.at/',
    alt: 'emp-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/fourreal-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://fourreal.eu/',
    alt: 'fourreal-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/sueba-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.sueba.at/de',
    alt: 'sueba-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/amt-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://amt-immobilien.at/',
    alt: 'amt-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/wk-development-bautraeger-neubauprojekt-wien.svg`,
    website: 'https://www.wk-development.com/',
    alt: 'wk-development-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/teammo-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.teammo.at/',
    alt: 'teammo-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/chambas-makler-neubauprojekte-wien.svg`,
    website: 'https://www.chambas.at/',
    alt: 'chambas-makler-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/seeste-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.seeste.at/',
    alt: 'seeste-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/jp-immobilien-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://jpi.at',
    alt: 'jp-immobilien-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/dekla-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.deba.at/de',
    alt: 'dekla-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/zplusp-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://zp-zt.at/',
    alt: 'zplusp-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/raiffaisen-wohnbau-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.raiffeisen-wohnbau.at/',
    alt: 'raiffaisen-wohnbau-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/winegg-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://www.winegg.at/',
    alt: 'winegg-bautraeger-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/adonia-bautraeger-neubauprojekte-wien.png`,
    website: 'https://www.adonia-immobilien.at/',
    alt: 'adonia-makler-neubauprojekte-wien',
  },
  {
    imageUrl: `${urlPrefix}/huebl-partner-bautraeger-neubauprojekte-wien.svg`,
    website: 'https://huebl-partner.com',
    alt: 'huebl-partner-bautraeger-neubauprojekte-wien',
  },
];

export default partners;
